import { render } from "./ViewMonthlyPayrollReport.vue?vue&type=template&id=0486ea38"
import script from "./ViewMonthlyPayrollReport.vue?vue&type=script&lang=js"
export * from "./ViewMonthlyPayrollReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__